import { initLocalization } from '@topconagriculture/language';

import { config, constants, NodeEnvEnum } from '.';

export const defaultLanguage = 'en';

initLocalization(config.RELEASE_VERSION, {
  lng: defaultLanguage,
  fallbackLng: defaultLanguage,
  ns: constants.translationsConfig.defaultNS,
  debug: config.NODE_END === NodeEnvEnum.development,
}).catch((err) => console.error(err));
